var LoadingButton = require("components/utility/LoadingButton");
var WhooosReadingClientApi = require("wr_apis/apis/wr_client_api/node_package/src/index.js")
var ValidatingInput = require("components/utility/ValidatingInput");
var CurrentUser = require("lib/account/CurrentUser");

require("logins/reset_password_page.scss");

class ResetPasswordPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false
		};
	}

	getUserID() {
		return $wr.getURLParameterByName("user_id");
	}

	getResetToken() {
		return $wr.getURLParameterByName("token");
	}

	validateForm() {
		return this.refs.password.validate() &
			this.refs.passwordConfirmation.validate();
	}

	onSubmit(e) {
		$wr.nope(e)
		if (!this.validateForm()) {
			return;
		}

		var client = new WhooosReadingClientApi.LegacyClient();
		this.setState({ loading: true });
		var params = { 
			user_id: this.getUserID(),
			token: this.getResetToken(),
			password_reset: {
				password: this.refs.password.val(),
				password_confirmation: this.refs.passwordConfirmation.val() 
			}
		};
		client.postPasswordResets(params, function(response) {
			var resetData = response.password_reset;
			if (resetData.errors && resetData.errors.length > 0) {
				window.wrNotifications.triggerDropDownNotification({
					text: resetData.errors.join(", "), 
					icon: "exclamation-sign", type: "error" }, 6000);	

				this.setState({ loading: false });

			} else {
				window.wrNotifications.triggerDropDownNotification({
					title: "Reset!", text: "Your password has been reset. Now, please log in.", 
					icon: "ok-sign" }, 6000);

				if (CurrentUser.isSignedIn()) {
					CurrentUser.logOut();
				}
				$wr.redirect("/login");
			}
		}.bind(this));
	}

	render() {
		return (
			<div className="resetPasswordPage container">
				<header className="pageHeader">
					<h1>Change Password</h1>
				</header>

				<form onSubmit={ this.onSubmit } className="resetForm">
					<label htmlFor="password">
						Password
					</label>
					<ValidatingInput type="password" ref="password"
						validators={ ValidatingInput.Validators.PRESENT }
						inputClassName="form-control password" 
						defaultSubText="At least 6 characters" />


					<label htmlFor="passwordConfirmation">
						Password confirmation
					</label>
					<ValidatingInput type="password" ref="passwordConfirmation"
						validators={ ValidatingInput.Validators.PRESENT }
						inputClassName="form-control password" />

					<div className="btnLine">
						<LoadingButton text="Reset Password" loading={ this.state.loading } 
							className="btn buttonPrimary" />
					</div>
				</form>
			</div>
		);
	}

	componentDidMount() {
		var client = new WhooosReadingClientApi.LegacyClient();
		var params = { user_id: this.getUserID(), token: this.getResetToken() };

		client.getPasswordResets(params, function(response) {
			var resets = response.password_resets;
			if (resets == undefined || resets.length == 0) {
				window.wrNotifications.triggerDropDownNotification({
					text: "Your reset link has expired!", icon: "exclamation-sign", type: "error" });

				$wr.redirect("/login");
			}
		}.bind(this));
	}
};

ResetPasswordPage.propTypes = PageStrictPropTypes({
	// location has query, query has "user_id" and "token"
	query: PropTypes.object
});

module.exports = ResetPasswordPage;


// WEBPACK FOOTER //
// ./modules/components/logins/ResetPasswordPage.js